import React from "react";
import KartSimulation from "./KartSimulation";

function App() {
  return (
    <div className="p-4">
      {/* Logo at the top */}
      <div className="flex justify-center mb-4">
        <img src="/logo.png" alt="Kart Simulation Logo" className="h-16" />
      </div>
      {/* <h1 className="text-xl font-bold text-center">Cold Pressure Estimator</h1>*/}
      <KartSimulation />
    </div>
  );
}

export default App;
